export const EMAIL_SIDEBAR = [
  {
    id: 1,
    className: "icon-folder",
    title: "All mail",
  },
  {
    id: 2,
    className: "icon-new-window",
    title: "Sent",
    badge: 69,
  },
  {
    id: 3,
    className: "icon-pencil-alt",
    title: "Draft",
    badge: 59,
  },
  {
    id: 4,
    className: "icon-trash",
    title: "Trash",
    badge: 99,
  },
  {
    id: 5,
    className: "icon-info-alt",
    title: "Important",
  },
  {
    id: 6,
    className: "icon-star",
    title: "Starred",
  },
  {
    id: 7,
    line: <hr />,
  },
  {
    id: 8,
    className: "icon-email",
    title: "UNREAD",
  },
  {
    id: 9,
    className: "icon-export",
    title: "Spam",
  },
  {
    id: 10,
    className: "icon-share",
    title: "OUTBOX",
  },
  {
    id: 11,
    className: "icon-file",
    title: "UPDATE",
  },
  {
    id: 12,
    className: "icon-bell",
    title: "ALERT",
  },
  {
    id: 13,
    className: "icon-notepad",
    title: "NOTES",
    badge: "20",
  },
];

export const EMAIL_LIST = [
  {
    tittle: "Pork Lorn",
    date: 15,
    month: "July",
    year: 2023,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
  {
    tittle: "Peg Legge",
    date: 20,
    month: "january",
    year: 2023,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
  {
    tittle: "Hileri makr",
    date: 20,
    month: "August",
    year: 2023,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
  {
    tittle: "Lion Lorpa",
    date: 2,
    month: "Jun",
    year: 2016,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
  {
    tittle: "Solvn Relto",
    date: 25,
    month: "july",
    year: 2015,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
  {
    tittle: "Repro Soft",
    date: 15,
    month: "july",
    year: 2023,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
  {
    tittle: "Lion Lorpa",
    date: 2,
    month: "jun",
    year: 2016,
    paragraph: "Mattis luctus. Donec nisi diam",
  },
];

export const EMAIL_APP_IMAGES = [
  {
    icon: "reply",
    text: "Reply",
  },
  {
    icon: "reply-all",
    text: "ReplyAll",
  },
  {
    icon: "share",
    text: "Forward",
  },
];
